import { type FormEvent, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { ApiError } from '../api/client';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const { signIn, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  if (user) {
    // Already signed in — go home or to ?next=.
    const params = new URLSearchParams(location.search);
    const next = params.get('next') ?? '/';
    navigate(next, { replace: true });
    return null;
  }

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (busy) return;
    setErr(null);
    setBusy(true);
    try {
      await signIn(email.trim(), password);
      const params = new URLSearchParams(location.search);
      const next = params.get('next') ?? '/';
      navigate(next, { replace: true });
    } catch (e2) {
      if (e2 instanceof ApiError && e2.status === 429) {
        setErr('Too many attempts. Wait a moment and try again.');
      } else {
        setErr('Invalid email or password.');
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-shell">
      <div className="login-card">
        <div className="login-eyebrow">Hensley Heritage</div>
        <div className="login-brand">Batch Tracker</div>
        <div className="login-sub">Sign in to continue to your workspace.</div>
        <form className="login-form" onSubmit={onSubmit}>
          <div className="field">
            <label className="field-label">Email</label>
            <input
              className="field-input"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="field">
            <label className="field-label">Password</label>
            <input
              className="field-input"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          {err && <div className="login-error">{err}</div>}
          <button
            className="btn btn-primary login-submit"
            type="submit"
            disabled={busy}
          >
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
        <div className="login-foot">
          Accounts are created by the workspace owner.
        </div>
      </div>
    </div>
  );
}
